import { Action, BodyUpdateAction, TypeChangeAction } from './types'
import { ILeaf, INode } from 'shared/types/tree'
import { isLeaf, isNode, doInBatches } from 'shared/utils'
import {
  doUpdate,
  idsForNode,
  UpdateMethod,
  UpdateType,
} from '../nodeUpdates/utility'
import { NodeIdMap } from '../../version_mapping/utility'
import {
  UpdateData,
  UpdateLeafUpdateData,
  UpdateNodeUpdateData,
} from '../nodeUpdates/types'

export function doTheAction(
  action: Action,
  items: (ILeaf | INode)[],
  idMap: NodeIdMap,
) {
  const doAction = async (item: ILeaf | INode) => {
    switch (action.actionType) {
      case 'delete':
        return doDeleteAction(item)
      case 'bodyUpdate':
        return doBodyUpdateAction(item, action, idMap)
      case 'typeChange':
        return doTypeChange(item, action)
    }
  }
  return doInBatches(items, doAction)
}

function updateTypeForItem(item: INode | ILeaf) {
  return isNode(item)
    ? UpdateType.node
    : isLeaf(item)
      ? UpdateType.leaf
      : undefined
}

function doDeleteAction(item: ILeaf | INode) {
  const updateType = updateTypeForItem(item)
  if (!updateType) return
  const params: UpdateData = {
    type: updateType,
    ids: idsForNode(item),
    method: UpdateMethod.delete,
  }
  return doUpdate(params)
}

function doBodyUpdateAction(
  item: ILeaf | INode,
  action: BodyUpdateAction,
  idMap: NodeIdMap,
) {
  if (isNode(item)) {
    const existingNode = idMap[item.id]?.node
    if (!existingNode) return
    const body = {
      ...existingNode.body,
      ...action.data,
    }
    const params: UpdateNodeUpdateData = {
      type: UpdateType.node,
      ids: idsForNode(existingNode),
      method: UpdateMethod.update,
      params: { body },
    }
    return doUpdate(params)
  }
  if (isLeaf(item)) {
    const parentNode = idMap[item.parent_id ?? '']?.node
    if (!parentNode) return
    const existingLeaf = parentNode.leaves?.find(({ id }) => id === item.id)
    if (!existingLeaf) return
    const body = {
      ...existingLeaf.body,
      ...action.data,
    }
    const params: UpdateLeafUpdateData = {
      type: UpdateType.leaf,
      ids: idsForNode(item),
      method: UpdateMethod.update,
      params: { body },
    }
    return doUpdate(params)
  }
}

function doTypeChange(item: ILeaf | INode, action: TypeChangeAction) {
  const updateType = updateTypeForItem(item)
  if (!updateType) return
  const params: UpdateData = {
    ids: idsForNode(item),
    type: updateType,
    method: UpdateMethod.update,
    params: {
      type: action.data.newType,
    },
  }
  return doUpdate(params)
}
